import React from 'react'
import {useEffect} from 'react'
import isScrapping from 'App/helpers/misc/isScrapping'

export default function FidelityToolsIntegration(props) {
  const {integrations: config} = props
  const validate =
    !isScrapping && config && config.integrations && config.integrations.fidelityToolsPush

  useEffect(() => {
    if (validate) {
      const script = document.createElement('script')
      const url = 'https://control.fidelitytools.net/public/scripts/fidelitytools-push.js'
      const css = document.createElement('link')
      const hrefStyle = 'https://control.fidelitytools.net/public/styles/fidelitytools-push.css'

      script.src = url
      script.async = true

      css.href = hrefStyle
      css.async = true

      document.body.appendChild(script)
      document.body.appendChild(css)

      return () => {
        document.body.removeChild(script)
        document.body.removeChild(css)
      }
    }
  }, [config])

  return validate ? (
    <div
      className="fidelitytools-push-btn"
      data-idRecurso={config.integrations.fidelityToolsPush}></div>
  ) : null
}
